import { validateMaxArrayLength } from 'hb-react/shared/utils/validators/maxArrayLength';
import { validateRequired } from 'hb-react/shared/utils/validators/required';

export const validateSelect = ({
  required,
  maxArrayLength,
  maxArrayLengthErrorMessage,
  value,
}) => {
  let error;

  if (required) {
    error = validateRequired(value);
  }

  if (maxArrayLength && !error) {
    error = validateMaxArrayLength(
      value,
      maxArrayLength,
      maxArrayLengthErrorMessage,
    );
  }

  return error;
};
